import api from '@/configs/GlobalRequestHandler.js';

export default {
  createRaffle:(raffleBody) => {
    // Rifas grandes (ex.: 1M cotas) demoram no servidor; timeout curto gera “erro” falso.
    return api.postRequestWithBody('/campaigns', raffleBody, {
      timeout: 180000,
    })
  },
  updateRaffle:(raffleId, raffleBody) => {
    return api.putRequestWithBody(`/campaigns/${raffleId}`, raffleBody)
  },
  updateShowWinnersPage: (raffleId, show_winners_page) => {
    return api.putRequestWithBody(`/campaigns/${raffleId}/show-winners-page`, {
      show_winners_page,
    })
  },
  updatePrizeRelease: (raffleId, body) => {
    return api.putRequestWithBody(`/campaigns/${raffleId}/prize-release`, body)
  },
  reportError:(body) => {
    return api.postRequestWithBody('/campaigns/report-error', body)
  },
  getRaffle:(raffleSlug) => {
    return api.getRequest(`/campaigns/${raffleSlug}`)
  },
  getAwardedQuotas:(raffleSlug) => {
    return api.getRequest(`/campaigns/${raffleSlug}/awarded-quotas`)
  },
  postHoraPremiadaWinners: (raffleSlug, body) => {
    return api.postRequestWithBody(`/campaigns/${raffleSlug}/hora-premiada`, body)
  },
  postNewRaffleImage:(raffleId, body) => {
    return api.postRequestWithBody(`/campaigns_images/${raffleId}`, body)
  },
  deleteRaffleImages:(raffleId, body) => {
    return api.deleteRequestWithBody(`/campaigns_images/${raffleId}`, body)
  },
  getRafflesMinimum: () => {
    return api.getRequest('/campaigns/minimum')
  },
  getRafflesByUser: (userId, search) => {
    let url = `/admin/campaigns/user/${userId}`;
    if (search) {
        url += `?search=${encodeURIComponent(search)}`;
    }
    return api.getRequest(url)
  },
  getCampaigns: (search, page = 1, perPage = 10) => {
    let url = `/campaigns?page=${page}&per_page=${perPage}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    return api.getRequest(url);
  },
  getAdminCampaigns: (page, search, systemWallet) => {
    let url = `/admin/campaigns?page=${page || 1}&per_page=10`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    if (systemWallet) {
      url += `&system_wallet=true`;
    }
    return api.getRequest(url);
  },
  getAdminCampaignsMetrics: () => {
    return api.getRequest('/admin/campaigns/metrics');
  },
  markActive: (id) => {
    return api.putRequestWithBody(`/admin/campaigns/mark_active/${id}`, {});
  },
  generateCaption: (body) => {
    return api.postRequestWithBody('/ai/raffle-caption', body);
  },
}